import axiosInstance from './axiosInstance';

export const saveEmbryologySummaryData = async (patientId, data, cycleId) => {
  return await axiosInstance
    .post(
      `/embryology/summary/create?patientId=${patientId}&cycleId=${cycleId}`,
      data,
    )
    .then((response) => response)
    .catch((error) => {
      console.error('Error saving summary:', error);
      throw error;
    });
};

export const fetchEmbryologySummary = async (patientId, cycleId) => {
  return await axiosInstance
    .get(`/embryology/summary?patientId=${patientId}&cycleId=${cycleId}`)
    .then((response) => response)
    .catch((error) => {
      console.error('Error fetching summary:', error);
      throw error;
    });
};

export const saveEmbryologyBiopsyData = async (patientId, data, cycleId) => {
  return await axiosInstance
    .post(
      `/embryology/biopsy/create?patientId=${patientId}&cycleId=${cycleId}`,
      data,
    )
    .then((response) => response)
    .catch((error) => {
      console.error('Error saving biopsy:', error);
      throw error;
    });
};

export const fetchEmbryologyBiopsy = async (patientId, cycleId) => {
  return await axiosInstance
    .get(`/embryology/biopsy?patientId=${patientId}&cycleId=${cycleId}`)
    .then((response) => response)
    .catch((error) => {
      console.error('Error fetching biopsy:', error);
      throw error;
    });
};

export const saveEmbryologyOocyteEmbryoRecord = async (
  patientId,
  data,
  cycleId,
) => {
  return await axiosInstance
    .post(
      `/embryology/oocyte/create?patientId=${patientId}&cycleId=${cycleId}`,
      data,
    )
    .then((response) => response)
    .catch((error) => {
      console.error('Error saving Records:', error);
      throw error;
    });
};

export const fetchEmbryologyCryopreservation = async (patientId, cycleId) => {
  return await axiosInstance
    .get(
      `/embryology/cryopreservation?patientId=${patientId}&cycleId=${cycleId}`,
    )
    .then((response) => response)
    .catch((error) => {
      console.error('Error fetching Cryopreservation:', error);
      throw error;
    });
};

export const saveEmbryologyCryopreservation = async (
  patientId,
  data,
  cycleId,
) => {
  return await axiosInstance
    .post(
      `/embryology/cryopreservation/create?patientId=${patientId}&cycleId=${cycleId}`,
      data,
    )
    .then((response) => response)
    .catch((error) => {
      console.error('Error saving Records:', error);
      throw error;
    });
};

export const fetchEmbryologyFreezingInventory = async (patientId) => {
  return await axiosInstance
    .get(`/embryology/freezingInventory?patientId=${patientId}`)
    .then((response) => response)
    .catch((error) => {
      console.error('Error fetching Inventory:', error);
      throw error;
    });
};

export const saveEmbryologyFreezingInventory = async (patientId, data) => {
  return await axiosInstance
    .post(`/embryology/freezingInventory?patientId=${patientId}`, data)
    .then((response) => response)
    .catch((error) => {
      console.error('Error saving Inventory:', error);
      throw error;
    });
};

export const fetchEmbryologyOocyteEmbryoRecord = async (patientId, cycleId) => {
  return await axiosInstance
    .get(`/embryology/oocyte?patientId=${patientId}&cycleId=${cycleId}`)
    .then((response) => response)
    .catch((error) => {
      console.error('Error fetching Records:', error);
      throw error;
    });
};

export const fetchEmbryologySummaryReport = async (patientId, cycleId) => {
  return await axiosInstance
    .get(`/embryology/summaryReport?patientId=${patientId}&cycleId=${cycleId}`)
    .then((response) => response)
    .catch((error) => {
      console.error('Error fetching summary report:', error);
      throw error;
    });
};

export const generateSummaryReport = async (patientId, summaryId, cycleId) => {
  return await axiosInstance
    .get(
      `/embryology/summary/report?patientId=${patientId}&summaryId=${summaryId}&cycleId=${cycleId}`,
    )
    .then((response) => response)
    .catch((error) => {
      console.error('Error generating report:', error);
      throw error;
    });
};
export const generateOPUSummaryReport = async (patientId, cycleId) => {
  return await axiosInstance
    .get(`/embryology/opu/report?patientId=${patientId}&cycleId=${cycleId}`)
    .then((response) => response)
    .catch((error) => {
      console.error('Error generating report:', error);
      throw error;
    });
};

export const generateOocyteEmbryoReport = async (patientId, oocyteReportId) => {
  return await axiosInstance
    .get(
      `/embryology/oocyte/report?patientId=${patientId}&oocyteReportId=${oocyteReportId}`,
    )
    .then((response) => response)
    .catch((error) => {
      console.error('Error generating report:', error);
      throw error;
    });
};

export const saveAndGenerateOPUReport = async (patientId, data, cycleId) => {
  return await axiosInstance
    .post(
      `/embryology/summaryReport/create?patientId=${patientId}&cycleId=${cycleId}`,
      data,
    )
    .then((response) => response)
    .catch((error) => {
      console.error('Error generating report:', error);
    });
};
export const fetchEmbryologyTransferData = async (patientId, cycleId) => {
  return await axiosInstance
    .get(
      `/embryology/transferDetails?patientId=${patientId}&cycleId=${cycleId}`,
    )
    .then((response) => response)
    .catch((error) => {
      console.error('Error fetching transfer:', error);
      throw error;
    });
};

export const saveEmbryologyTransferData = async (patientId, data, cycleId) => {
  return await axiosInstance
    .post(
      `/embryology/transferDetails/create?patientId=${patientId}&cycleId=${cycleId}`,
      data,
    )
    .then((response) => response)
    .catch((error) => {
      console.error('Error saving transfer:', error);
      throw error;
    });
};
export const saveEmbryologyFrozenTransferData = async (
  patientId,
  data,
  cycleId,
) => {
  return await axiosInstance
    .post(
      `/embryology/frozenTransferDetails/create?patientId=${patientId}&cycleId=${cycleId}`,
      data,
    )
    .then((response) => response)
    .catch((error) => {
      console.error('Error saving transfer:', error);
      throw error;
    });
};

export const fetchOpuCycles = async (patientId) => {
  return await axiosInstance
    .get(`/embryology/get-patient-cycles/${patientId}`)
    .then((response) => response)
    .catch((error) => {
      console.error('Error fetching opu cycles:', error);
      throw error;
    });
};

export const completeOpuCycle = async (patientId, cycleId) => {
  return await axiosInstance
    .post(`/embryology/complete-cycle/${patientId}?cycleId=${cycleId}`)
    .then((response) => response)
    .catch((error) => {
      console.error('Error completing opu cycle:', error);
      throw error;
    });
};

export const createNewOpuCycle = async (patientId) => {
  return await axiosInstance
    .post(`/embryology/create-new-cycle/${patientId}`)
    .then((response) => response)
    .catch((error) => {
      console.error('Error creating opu cycle:', error);
      throw error;
    });
};

export const fetchFetCycles = async (patientId) => {
  return await axiosInstance
    .get(`/embryology/get-patient-fet-cycles/${patientId}`)
    .then((response) => response)
    .catch((error) => {
      console.error('Error fetching Fet cycles:', error);
      throw error;
    });
};

export const createNewFetCycle = async (patientId) => {
  return await axiosInstance
    .post(`/embryology/create-new-fet-cycle/${patientId}`)
    .then((response) => response)
    .catch((error) => {
      console.error('Error creating fet cycle:', error);
      throw error;
    });
};

export const fetchFetCycle = async (patientId, cycleId) => {
  return await axiosInstance
    .get(`/embryology/get-fet-cycle/${patientId}?cycleId=${cycleId}`)
    .then((response) => response)
    .catch((error) => {
      console.error('Error fetching Fet cycle:', error);
      throw error;
    });
};

export const updateFetCycle = async (patientId, cycleId, data) => {
  return await axiosInstance
    .post(`/embryology/update-fet-cycle/${patientId}?cycleId=${cycleId}`, data)
    .then((response) => response)
    .catch((error) => {
      console.error('Error updating Fet cycle:', error);
      throw error;
    });
};

export const fetchEmbryologyDataAnalyticsApi = ({
  page,
  pageSize,
  searchValue,
  searchByName = false,
  searchByPatientId = false,
  fromDate,
  toDate,
  reportType,
}) => {
  return axiosInstance
    .get(`/embryology/get-data-analytics`, {
      params: {
        page,
        pageSize,
        searchValue,
        searchByName: searchByName ? searchByName : undefined,
        searchByPatientId: searchByPatientId ? searchByPatientId : undefined,
        fromDate: fromDate ? fromDate.toISOString() : undefined,
        toDate: fromDate ? toDate.toISOString() : undefined,
        reportType,
      },
    })
    .then((response) => response)
    .catch((error) => {
      console.error('Error fetching all users:', error);
      throw error;
    });
};

export const downloadFETReport = async (patientId, cycleId) => {
  return await axiosInstance
    .get(
      `/embryology/transferDetails/report?patientId=${patientId}&cycleId=${cycleId}`,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error('Error downloading report:', error);
      throw error;
    });
};

export const completeFETCycleApi = async (patientId, cycleId) => {
  return await axiosInstance
    .post(
      `/embryology/transferDetails/complete?patientId=${patientId}&cycleId=${cycleId}`,
    )
    .then((response) => response)
    .catch((error) => {
      console.error('Error completing FET cycle:', error);
      throw error;
    });
};

export const downloadEmbryologyDataAnalyticsReportsApi = ({
  searchValue,
  searchByName = false,
  searchByPatientId = false,
  fromDate,
  toDate,
  reportType,
}) => {
  return axiosInstance
    .get('/embryology/get-data-analytics/download', {
      params: {
        searchValue,
        searchByName: searchByName ? searchByName : undefined,
        searchByPatientId: searchByPatientId ? searchByPatientId : undefined,
        fromDate: fromDate ? fromDate.toISOString() : undefined,
        toDate: fromDate ? toDate.toISOString() : undefined,
        reportType,
      },
    })
    .then((response) => response)
    .catch((error) => {
      console.error('Error fetching data analytics:', error);
      throw error;
    });
};
